import type { PropsWithChildren, ReactNode } from 'react';

interface MenuFrameProps extends PropsWithChildren {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  wide?: boolean;
  footer?: ReactNode;
  className?: string;
}

export function MenuFrame({ eyebrow, title, subtitle, wide, footer, className = '', children }: MenuFrameProps) {
  return (
    <section className={`menu-frame ${wide ? 'menu-frame--wide' : ''} ${className}`}>
      <header className="menu-frame__header">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        {subtitle && <p className="menu-frame__subtitle">{subtitle}</p>}
      </header>
      <div className="menu-frame__content">{children}</div>
      {footer && <footer className="menu-frame__footer">{footer}</footer>}
    </section>
  );
}

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  detail?: string;
  variant?: 'primary' | 'secondary' | 'danger' | 'quiet';
  icon?: string;
}

export function ActionButton({ label, detail, variant = 'secondary', icon, className = '', ...props }: ActionButtonProps) {
  return (
    <button className={`action-button action-button--${variant} ${className}`} {...props}>
      {icon && <span className="action-button__icon" aria-hidden="true">{icon}</span>}
      <span className="action-button__label">{label}</span>
      {detail && <span className="action-button__detail">{detail}</span>}
      <span className="action-button__chevron" aria-hidden="true">›</span>
    </button>
  );
}

export function BackButton({ onClick, label = 'Back' }: { onClick(): void; label?: string }) {
  return (
    <button className="back-button" onClick={onClick} aria-label={label}>
      <span aria-hidden="true">‹</span> {label}
    </button>
  );
}

export function BrandMark() {
  return (
    <div className="brand-mark" aria-hidden="true">
      <i />
      <i />
      <i />
    </div>
  );
}
